import { geometry as g } from '@progress/kendo-drawing';
import { TRANSPARENT } from '../constants';
import { VisualBase } from './VisualBase';
import { deepExtend } from './../utils/deep-extend';
const defaultOptions = {
    stroke: {
        color: TRANSPARENT,
        width: 0
    },
    fill: {
        color: 'black'
    }
};
/**
 * Base class for visual markers that can be positioned on paths.
 * Extends VisualBase and provides common functionality for marker positioning and transformation.
 */
export class MarkerBase extends VisualBase {
    /**
     * Creates a new MarkerBase instance.
     * @param options Configuration options for the marker
     */
    constructor(options) {
        options = deepExtend({}, defaultOptions, options);
        super(options);
        const anchor = this.options.anchor || {};
        this.anchor = new g.Point(anchor.x, anchor.y);
        this.createElement();
    }
    /**
     * Creates the drawing element for the marker. Should be overridden by subclasses.
     */
    createElement() { }
    /** @hidden */
    _transformToPath(point, path) {
        const transform = path.transform();
        if (point && transform) {
            point = point.transformCopy(transform);
        }
        return point;
    }
    /**
     * Redraws the marker with updated options.
     * @param options New options to apply to the marker
     */
    redraw(options) {
        if (options) {
            if (options.position) {
                this.options.position = options.position;
            }
            super.redraw(options);
        }
    }
}
